import {
  StatusRunning,
  StatusOK,
  StatusError,
} from '@backstage/core-components';
import { Chip, Tooltip } from '@material-ui/core';
import {
  Activity,
  ActivityStatus,
  STATUS_LABELS,
  PHASE_LABELS,
} from '../../api/types';
import { ControlPlaneCycleCell } from './ControlPlaneStateCells';

const StatusIndicator = ({
  status,
  errorMessage,
}: {
  status: ActivityStatus;
  errorMessage?: string | null;
}) => {
  switch (status) {
    case 'active':
      return <StatusRunning>{STATUS_LABELS.active}</StatusRunning>;
    case 'completed':
      return <StatusOK>{STATUS_LABELS.completed}</StatusOK>;
    case 'error': {
      const indicator = <StatusError>{STATUS_LABELS.error}</StatusError>;
      return errorMessage ? (
        <Tooltip title={errorMessage} arrow>
          <span>{indicator}</span>
        </Tooltip>
      ) : (
        indicator
      );
    }
    default:
      return <>{STATUS_LABELS[status]}</>;
  }
};

export const PhaseChip = ({ phase }: { phase: string }) => {
  const label = PHASE_LABELS[phase as keyof typeof PHASE_LABELS] ?? phase;
  return <Chip size="small" label={label} variant="outlined" />;
};

export function ActivityStatusCell({ activity }: { activity: Activity }) {
  return activity.controlPlane ? (
    <ControlPlaneCycleCell
      projection={activity.controlPlane}
      fallbackStatus={activity.status}
    />
  ) : (
    <StatusIndicator
      status={activity.status}
      errorMessage={activity.errorMessage}
    />
  );
}
